// Shared palette + typography constants for all scenes.
// Values taken from GDD §11.3 Color + type.

export const COLOR_BG_CLEAR = 0x000000;
export const COLOR_STAGE_BLUE = 0x060ce9;
export const COLOR_STAGE_BLUE_DIM = 0x040a80;
export const COLOR_WHITE = 0xffffff;
export const COLOR_GOLD = 0xffc43d;
export const COLOR_RED = 0xe23e3e;
export const COLOR_AMBER = 0xffa733;
export const COLOR_GREEN = 0x3dff85;
export const COLOR_PURPLE = 0xa86bff;
export const COLOR_PANEL_BG = 0x0b1033;
export const COLOR_PANEL_BORDER = 0x1a277a;

// Lazy-load Bebas/Inter/Oswald via a webfont; fall through to system stack until then.
export const FONT_DISPLAY = `'Bebas Neue', 'Impact', 'Arial Narrow', system-ui, sans-serif`;
export const FONT_UI = `'Inter', system-ui, -apple-system, sans-serif`;
export const FONT_SLAB = `'Roboto Slab', 'Georgia', serif`;
// Oswald is the brand display face used across DOM overlays (lobby, mini-LB,
// round splash). Exposed here so Three.js scenes can match the DOM look.
export const FONT_OSWALD = `'Oswald', 'Bebas Neue', 'Impact', sans-serif`;

/** Shared card geometry — keep UI consistent across scenes. */
export const CARD_RADIUS = 14;
export const CARD_SHADOW_COLOR = 'rgba(0,0,0,0.45)';
export const CARD_SHADOW_BLUR = 22;
export const CARD_SHADOW_OFFSET_Y = 8;

// Stage dims — orthographic so 1 world unit ≈ 1 pixel.
export const STAGE_WIDTH = 1920;
export const STAGE_HEIGHT = 1080;
